'use es6';

import I18n from 'I18n';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import { useGroupIndices } from '../SourceMeta';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GroupFilterControl = ({
  currentGroupId,
  onGroupSelected
}) => {
  const groupIndices = useGroupIndices().add(undefined);
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "200",
    as: "div",
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "snowflake-filtering-group-select",
      children: I18n.text('reporting-snowflake.filter-editor.editor-panel.group-with')
    }), /*#__PURE__*/_jsx(Select, {
      id: "snowflake-filtering-group-select",
      "data-test-id": "snowflake-filtering-group-select",
      onChange: ({
        target: {
          value
        }
      }) => onGroupSelected(value),
      options: groupIndices.toArray().map(groupIndex => ({
        text: groupIndex !== undefined && String(groupIndex + 1) || I18n.text('reporting-snowflake.filter-editor.editor-panel.none'),
        value: groupIndex
      })),
      placeholder: I18n.text('reporting-snowflake.filter-editor.editor-panel.select-group'),
      value: currentGroupId
    })]
  });
};